import React, { useContext } from 'react';
import { View } from './View';
import { GlobalContext } from '../../components/GlobalContext';

export const Container: React.FC = () => {
  const { loggedInUser, loading } = useContext(GlobalContext);

  return <View isLoading={loading} loggedInUser={loggedInUser} />;
};
